import {
  Flipped as Flipped,
  Flipper as Flipper,
} from 'react-flip-toolkit';
import { css as css } from '@emotion/css';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { NotBlankString__toString_impl_5tex9r3bdt5aydt9d7j as NotBlankString__toString_impl_5tex9r } from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
  addChildNodeajp8y977cuss as addChildNode,
} from '../../../../../../kotlin-react/react/ChildrenBuilder.mjs';
import { ReactHTML_instanced0ci4wsv0lrw as ReactHTML_instance } from '../../../../../../kotlin-react-dom/react/dom/html/ReactHTML.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PlayerCard292pm37x5pt2b as PlayerCard } from '../../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/player/PlayerCardKt.mjs';
import { createywkzgrq4l4xy as create } from '../../../../../../kotlin-react/react/create.mjs';
import { component12goe0t36bs1uq as component1 } from './LoadingPageFramePropsExtentions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_defaultPlayer3nrcomik61lqf as get_defaultPlayer } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/player/Player.mjs';
import { Companion_instance1efeo82wksowd as Companion_instance } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/player/PlayerId.mjs';
import { Companion_getInstance1l5ym9otmdi2n as Companion_getInstance } from '../../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/CouplingImages.mjs';
import { pairOf3vr52fdd2zexd as pairOf } from '../../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/pairassignmentdocument/CouplingPair.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { reversed22y3au42jl32b as reversed } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { nfcrfe5635r1kf5 as nfc } from '../../../../../../jsmints-minreact/com/zegreatrob/minreact/ReactFunction.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LoadingPageFrame() {
  _init_properties_LoadingPageFrame_kt__vvplsu();
  var tmp = KProperty0();
  return LoadingPageFrame$delegate.a1n(null, getPropertyCallableRef('LoadingPageFrame', 0, tmp, _get_LoadingPageFrame_$ref_w5j208(), null));
}
var LoadingPageFrame$delegate;
function flippedPlayer(leftCardStyles, player, top, tilt, left) {
  _init_properties_LoadingPageFrame_kt__vvplsu();
  var tmp = Flipped;
  return create(tmp, ($this$create) => {
    $this$create.flipId = NotBlankString__toString_impl_5tex9r(player.d2d_1.d2e_1);
    // Inline function 'react.Key' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    $this$create.key = NotBlankString__toString_impl_5tex9r(player.d2d_1.d2e_1);
    setDefaultKey($this$create, '@rdk/106_4');
    // Inline function 'react.dom.html.ReactHTML.div' call
    // Inline function 'react.IntrinsicType' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'react.ChildrenBuilder.invoke' call
    var block = ($this$div) => {
      // Inline function 'emotion.react.css' call
      // Inline function 'emotion.css.ClassName' call
      // Inline function 'js.objects.unsafeJso' call
      // Inline function 'js.objects.unsafeJso' call
      // Inline function 'kotlin.apply' call
      var this_0 = {};
      // Inline function 'web.cssom.Position.Companion.relative' call
      this_0.position = 'relative';
      this_0.top = top;
      this_0.left = left;
      $this$div.className = css(this_0);
      PlayerCard($this$div, player, leftCardStyles, VOID, 50, VOID, tilt);
      return Unit_instance;
    };
    addChild($this$create, 'div', block);
    return Unit_instance;
  });
}
function LoadingPageFrame$delegate$lambda($this$nfc, _destruct__k2r9zo) {
  _init_properties_LoadingPageFrame_kt__vvplsu();
  var state = component1(_destruct__k2r9zo);
  setDefaultKey($this$nfc, '@rdk/35_4');
  // Inline function 'react.dom.html.ReactHTML.div' call
  // Inline function 'react.IntrinsicType' call
  // Inline function 'js.reflect.unsafeCast' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$div) => {
    // Inline function 'emotion.react.css' call
    // Inline function 'emotion.css.ClassName' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'js.objects.unsafeJso' call
    // Inline function 'kotlin.apply' call
    var this_0 = {};
    // Inline function 'web.cssom.Display.Companion.flex' call
    this_0.display = 'flex';
    // Inline function 'web.cssom.JustifyContent.Companion.center' call
    this_0.justifyContent = 'center';
    // Inline function 'web.cssom.AlignItems.Companion.center' call
    this_0.alignItems = 'center';
    $this$div.className = css(this_0);
    setDefaultKey($this$div, '@rdk/41_8');
    // Inline function 'react.dom.html.ReactHTML.div' call
    // Inline function 'react.IntrinsicType' call
    // Inline function 'js.reflect.unsafeCast' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'react.ChildrenBuilder.invoke' call
    var block = ($this$div) => {
      // Inline function 'emotion.react.css' call
      // Inline function 'emotion.css.ClassName' call
      // Inline function 'js.objects.unsafeJso' call
      // Inline function 'js.objects.unsafeJso' call
      // Inline function 'kotlin.apply' call
      var this_0 = {};
      // Inline function 'web.cssom.Position.Companion.absolute' call
      this_0.position = 'absolute';
      // Inline function 'web.cssom.pct' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.top = toString(50) + '%';
      // Inline function 'web.cssom.pct' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.left = toString(50) + '%';
      // Inline function 'web.cssom.pct' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0 = toString(-50) + '%';
      // Inline function 'web.cssom.pct' call
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'web.cssom.translate' call
      var ty = toString(-50) + '%';
      // Inline function 'js.reflect.unsafeCast' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.transform = 'translate(' + toString(tmp0) + ',' + toString(ty) + ')';
      $this$div.className = css(this_0);
      var pair = pairOf(get_defaultPlayer().e2g(Companion_instance.c2c(), VOID, 'rob', VOID, VOID, VOID, Companion_getInstance().c3s_1.a3s_1), get_defaultPlayer().e2g(Companion_instance.c2c(), VOID, 'autumn', VOID, VOID, VOID, Companion_getInstance().c3s_1.b3s_1));
      var data = state.g7p_1;
      setDefaultKey($this$div, '@rdk/61_12');
      var tmp2 = Flipper;
      // Inline function 'react.ChildrenBuilder.invoke' call
      var block = ($this$Flipper) => {
        $this$Flipper.flipKey = data.toString();
        setDefaultKey($this$Flipper, '@rdk/63_16');
        // Inline function 'react.dom.html.ReactHTML.div' call
        // Inline function 'react.IntrinsicType' call
        // Inline function 'js.reflect.unsafeCast' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'react.ChildrenBuilder.invoke' call
        var block = ($this$div) => {
          setDefaultKey($this$div, '@rdk/64_20');
          // Inline function 'react.dom.html.ReactHTML.div' call
          // Inline function 'react.IntrinsicType' call
          // Inline function 'js.reflect.unsafeCast' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'react.ChildrenBuilder.invoke' call
          var block = ($this$div) => {
            // Inline function 'emotion.react.css' call
            // Inline function 'emotion.css.ClassName' call
            // Inline function 'js.objects.unsafeJso' call
            // Inline function 'js.objects.unsafeJso' call
            // Inline function 'kotlin.apply' call
            var this_0 = {};
            // Inline function 'web.cssom.Display.Companion.inlineFlex' call
            this_0.display = 'inline-flex';
            $this$div.className = css(this_0);
            // Inline function 'emotion.css.ClassName' call
            // Inline function 'js.objects.unsafeJso' call
            // Inline function 'js.objects.unsafeJso' call
            // Inline function 'kotlin.apply' call
            var this_1 = {};
            var tmp$ret$63 = css(this_1);
            var tmp = flippedPlayer(tmp$ret$63, pair.o2d_1, data.z7o_1, data.y7o_1, data.a7p_1);
            // Inline function 'emotion.css.ClassName' call
            // Inline function 'js.objects.unsafeJso' call
            // Inline function 'js.objects.unsafeJso' call
            // Inline function 'kotlin.apply' call
            var this_2 = {};
            var tmp$ret$68 = css(this_2);
            // Inline function 'kotlin.let' call
            var it = listOf([tmp, flippedPlayer(tmp$ret$68, pair.p2d_1, data.c7p_1, data.b7p_1, data.e7p_1)]);
            var tmp_0;
            if (data.d7p_1) {
              tmp_0 = reversed(it);
            } else {
              tmp_0 = it;
            }
            // Inline function 'kotlin.collections.forEach' call
            var _iterator__ex2g4s = tmp_0.p1();
            while (_iterator__ex2g4s.q1()) {
              var element = _iterator__ex2g4s.r1();
              // Inline function 'react.ChildrenBuilder.unaryPlus' call
              addChildNode($this$div, element);
            }
            return Unit_instance;
          };
          addChild($this$div, 'div', block);
          return Unit_instance;
        };
        addChild($this$Flipper, 'div', block);
        return Unit_instance;
      };
      addChild($this$div, tmp2, block);
      return Unit_instance;
    };
    addChild($this$div, 'div', block);
    return Unit_instance;
  };
  addChild($this$nfc, 'div', block);
  return Unit_instance;
}
function _get_LoadingPageFrame_$ref_w5j208() {
  return constructCallableReference(() => get_LoadingPageFrame(), 0, 0, 260);
}
var properties_initialized_LoadingPageFrame_kt_7fkg5g;
function _init_properties_LoadingPageFrame_kt__vvplsu() {
  if (!properties_initialized_LoadingPageFrame_kt_7fkg5g) {
    properties_initialized_LoadingPageFrame_kt_7fkg5g = true;
    LoadingPageFrame$delegate = nfc(LoadingPageFrame$delegate$lambda);
  }
}
//region block: exports
export {
  get_LoadingPageFrame as get_LoadingPageFrame3va2mhcnct771,
};
//endregion

//# sourceMappingURL=LoadingPageFrame.mjs.map
